<template>
	<!-- 关于我们 -->
	<div class="content1">
		<header1 :pathname="pathname" @showMobile="showMobile"></header1>
		        
		<div class="medium">
			<div class="medium-menu">
				新闻媒体 > 新闻详情
			</div>
			<div class="medium-cd">
				<div class="medium-l" v-if="info">
					<div class="medium-l-h">
						<div class="h">
							{{info.barticleTile}}
						</div>
						<div class="time">
							{{info.createTime.split('00:00:00')[0]}}
						</div>
					</div>
					<div class="medium-l-f" v-html="info.bcontent">
						
					</div>
					<div class="medium-l-b" @click="tapback">
						返回列表
					</div>
				</div>
				<div class="medium-r">
					<div class="medium-r-h">
						相关新闻
					</div>
					<div class="item" v-for="(item, index) in list" :key="index"
					@click="goDetails(item)">
						<img :src="item.barticleUrl" alt="">
						<div class="item-t">
							{{item.barticleTile}}
						</div>
						<div class="item-s">
							{{item.barticleMeta}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer1></footer1>
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>
</template>

<script>
	import mobilemenu from "@/components/mobile-menu.vue";
	import header1 from "@/components/header.vue";
	import footer1 from "@/components/footer.vue";
	import {
	  contentDetails,
	  contentlist
	} from '@/api/home.js'
	export default {
		components: {
			mobilemenu,
			header1,
			footer1,
		},
		data() {
			return {
				pathname: "medium",
				menutitle:"新闻媒体",
				info:null,
				id:-1,
				list:[]
			}
		},
		created() {
			this.id = this.$route.query.id
			this.getcontentDetails()
			this.getcontentlist()
		},   
		methods: {
			getcontentDetails() {
				contentDetails({
					id:this.id
				}).then(res => {
				  if (res.data.code == 200) {
				    this.info = res.data.data
				  }
				})
			},
			getcontentlist() {
				contentlist({
				    pageNum: 1,
					pageSize:5,
					companyId:1,
					categoryId:442,
					bdeviceType:2
				}).then(res => {
				  if (res.data.code == 200) {
				    this.list = res.data.rows
				  }
				})
			},
			tapback(){
				this.$router.push({path:"/medium"}) 
			},
			tapMenu(e) {
				this.selectIndex = e
			},
			goDetails(item){
				this.id = item.bid
				this.getcontentDetails()
				this.getcontentlist()
			},
			showMobile() {
				console.log("ooooo")
				this.isShowMobile = true
			},
			hiddenMobile() {
				this.isShowMobile = false
			}

		}
	}
</script>

<style lang="scss">
	.content1 {
		.medium {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			.medium-menu {
				
				color: #999999;
			}
			.medium-cd {
				
				display: flex;
				justify-content: flex-start;
				.medium-l {
					
					
					.medium-l-h {
						flex-direction: column;
						justify-content: flex-start;
				
						
						.time {
						
							color: #666;
						}
					}
					.medium-l-f {
					
						color: #666666;
					}
					.medium-l-b {
						cursor: pointer;
						color: white;
						text-align: center;
						background-color: #22A3D3;
					}
				}
				.medium-r {
	
					.medium-r-h {
						color: #333;
					}
					.item {
						justify-content: flex-start;
						flex-direction: column;
						.item-t {
							color: #332C2B;
						}
						.item-s {
							color: #999;
						}
					}
				}
			}
		}
	}
	
	
	
	@media screen and (min-width: 1200px) {
		.content1 {
			padding-top: 100px;
			.medium {
				width: 100%;
				display: flex;
				padding-bottom: 40px;
				.medium-menu {
					margin-top: 36px;
					width: 1200px;
					font-size: 15px;
				}
				.medium-cd {
					margin-top: 40px;
					width: 1200px;
					display: flex;
					.medium-l {
						width: 70%;
						box-sizing: border-box;
						padding-right: 30px;
						border-right: 1px solid #f5f5f5;
						.medium-l-h {
							display: flex;
							border-bottom: 1px solid #f5f5f5;
							padding-bottom: 16px;
							.h {
								font-size: 24px;
							}
							.time {
								margin-top: 14px;
								font-size: 16px;
							}
						}
						.medium-l-f {
							padding: 40px 0;
							font-size: 16px;
						}
						.medium-l-b {
							width: 130px;
							height: 45px;
							border-radius: 3px;
							line-height: 48px;
							
						}
					}
					.medium-r {
						width: 30%;
						box-sizing: border-box;
						padding-left: 20px;
						height: 100%;
						.medium-r-h {
							font-size: 24px;
							margin-top: 24px;
							margin-bottom: 24px;
						}
						.item {
							width: 100%;
							margin-bottom: 40px;
							display: flex;
							img {
								width: 100%;
								height: 220px;
							}
							.item-t {
								margin-top: 12px;
								font-size: 20px;
							}
							.item-s {
								margin-top: 12px;
								font-size: 15px;
							}
						}
					}
				}
			}
		}
	
	}
	@media screen and (max-width: 1200px) {
		.content1 {
			padding-top: 80px;
			.medium {
				width: 100%;
				display: flex;
				padding-bottom: 30px;
				.medium-menu {
					margin-top: 24px;
					width: 100%;
					font-size: 14px;
					padding: 0 20px;
				}
				.medium-cd {
					margin-top: 30px;
					width: 100%;
					display: flex;
					padding: 0 20px;
					.medium-l {
						width: 70%;
						padding-right: 20px;
						border-right: 1px solid #f5f5f5;
						.medium-l-h {
							display: flex;
							padding-bottom: 12px;
							.h {
								font-size: 18px;
							}
							.time {
								margin-top: 12px;
								font-size: 14px;
							}
						}
						.medium-l-f {
							padding: 30px 0;
							font-size: 14px;
						}
						.medium-l-b {
							width: 100px;
							height: 40px;
							border-radius: 3px;
							line-height: 40px;
							
						}
					}
					.medium-r {
						width: 30%;
						padding-left: 20px;
						height: 100%;
						.medium-r-h {
							font-size: 18px;
							margin-top: 12px;
							margin-bottom: 12px;
						}
						.item {
							width: 100%;
							margin-bottom: 30px;
							display: flex;
							img {
								width: 100%;
								height: 180px;
							}
							.item-t {
								margin-top: 10px;
								font-size: 16px;
							}
							.item-s {
								margin-top: 10px;
								font-size: 13px;
							}
						}
					}
				}
			}
		}
	
	}
	@media screen and (max-width: 880px) {
		.content1 {
			padding-top: 50px;
			.medium {
				width: 100%;
				display: flex;
				padding-bottom: 20px;
				.medium-menu {
					margin-top: 16px;
					width: 100%;
					font-size: 13px;
					padding: 0 16px;
				}
				.medium-cd {
					margin-top: 20px;
					width: 100%;
					display: flex;
					padding: 0 16px;
					.medium-l {
						width: 100%;
						padding-right: 0px;
						border-right: 0;
						.medium-l-h {
							display: flex;
							padding-bottom: 12px;
							.h {
								font-size: 16px;
							}
							.time {
								margin-top: 12px;
								font-size: 13px;
							}
						}
						.medium-l-f {
							padding: 20px 0;
							font-size: 14px;
						}
						.medium-l-b {
							width: 80px;
							height: 40px;
							border-radius: 3px;
							line-height: 40px;
							
						}
					}
					.medium-r {
						width: 30%;
						display: none;
						
					}
				}
			}
		}
	
	}
</style>
